import React from "react";

export default function ConfirmDialog({ title, message, onCancel, onConfirm, confirmLabel = "Delete" }) {
  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal-card" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <h3 className="text-xl font-extrabold mb-2">{title}</h3>
        <p className="muted mb-6">{message}</p>
        <div className="flex justify-end gap-2">
          <button className="pill-btn outline" onClick={onCancel}>Cancel</button>
          <button className="pill-btn primary" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
